import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { MyCollegePage } from '@features/college-overview/components/MyCollegePage'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/college')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load college overview'>
            <Suspense fallback={<LoadingIndicator resource='college overview' />}>
                <MyCollegePage />
            </Suspense>
        </QueryErrorBoundary>
    )
}